import sessionExpireModal from './sessionExpireModal.html';

export default class MainController {

    static get $inject() {
        return ['$state', 'VERSION', 'AuthService', 'LanguageService', '$element', 'ApiPanelsService', 'CookiesService',
            'ApiAccountService', 'Idle', '$uibModal', '$scope', 'UiHelper', '$timeout'
        ];
    }

    constructor($state, VERSION, AuthService, LanguageService, $element, ApiPanelsService, CookiesService,
                ApiAccountService, Idle, $uibModal, $scope, UiHelper, $timeout) {

        this._VERSION = VERSION;
        this._$state = $state;
        this._AuthService = AuthService;
        this.LanguageService = LanguageService;
        this.ApiPanelsService = ApiPanelsService;
        this.CookiesService = CookiesService;
        this.ApiAccountService = ApiAccountService;
        this.$scope = $scope;
        this.UiHelper = UiHelper;
        this.$timeout = $timeout;
        document.body.style.backgroundColor = '#002F6C'; // SECOM background color

        $scope.closeWarningModals = () => {
            $scope.warning.close();
            $scope.warning = null;
            this.$timeout.cancel(this.stopped);
            this.setSessionProgressbarCounter();
        };

        $scope.closeModals = () => {
            if ($scope.warning) {
                UiHelper.closeModals();
                $scope.closeWarningModals();
            }
        };

        $scope.$on('IdleStart', () => {
            $scope.warning = $uibModal.open({
                template: sessionExpireModal,
                windowClass: 'modal-danger zindex',
                backdrop: 'static',
                keyboard: false,
                scope: $scope
            });
            this.setSessionProgressbarCounter();
            this.countdown();
        });

        $scope.$on('IdleEnd', () => {

        });

        $scope.$on('IdleTimeout', () => {
            $scope.closeModals();
            this.logout();
        });

        $scope.start = () => {
            Idle.watch();
            $scope.started = true;
        };

        $scope.logout = () => {
            this.logout();
            $scope.closeModals();
            Idle.unwatch();
            $scope.started = false;
        };

        $scope.start();

        $element.on('$destroy', () => {
            this.closeModal('languageModal');
        });
    }

    setSessionProgressbarCounter() {
       this.$scope.countdownTimer = 60;
    }

    countdown() {

        this.stopped = this.$timeout(() => {

            --this.$scope.countdownTimer;
            this.countdown();

            if(this.$scope.countdownTimer == 0){
                this.logout();
            }

        }, 1000);
    }

    logout() {
        this._AuthService.logout(() => {
            this._$state.go('login');
        })
    }

    closeModal(modalName) {
        this.UiHelper.closeModal(modalName);
    }

    showModal(modalName) {
        this.UiHelper.showModal(modalName);
    }

    get version() {
        return this._VERSION;
    }

    getUserFullName() {
        this.userFullName = this.ApiAccountService.getUserFullName();
        return this.userFullName;
    }

}


/** WEBPACK FOOTER **
 ** ./src/main/controller.js
 **/